(ns frontend.view.modals.notification.view
  (:require
   [ui.components.button.view :as button]
   [ui.components.modal.view :as modal]))

(defonce modal-key :notification-modal)

(defn view
  [{:keys [shown? close-modal! props class-name topmost?]}]
  (let [{:keys [ok-button-text cancel-button-text title body-text 
                ok-button-color
                on-ok! on-cancel!]}
        props]
    [modal/view
     {:visible?      (and shown? topmost?)
      :hide!         close-modal!
      :backdrop      "static"
      :close-button? true}
     title
     [:p.zap-modal__body__row.text-center
      body-text]
     [:<>
      (when cancel-button-text
        [:div
         {:class "flex items-center gap-3"}
         [button/secondary-hollow
          {:on-click (fn [_]
                       (close-modal!)
                       (when on-cancel!
                         (on-cancel!)))}
          cancel-button-text]])
      [modal/left-single-button
       ok-button-color
       false
       (fn [_]
         (close-modal!)
         (when on-ok!
           (on-ok!)))
       ok-button-text]]]))
